import components from './components.json';

export const STOREFRONT_COMPONENTS = components;
export const getComponentLabel = (handleOrKey: string, fallback = 'Storefront component'): string =>
    Object.entries(components).find(([handle, component]) =>
        handle === handleOrKey || component.key === handleOrKey)?.[1].label ?? fallback;

// Translation group IDs remain stable; only their headings use product names.
export const getTranslationGroupLabel = (group: string): string => {
    const handles: Record<string, keyof typeof components> = {
        'Vehicle Search': 'vehicle_search_bar',
        'Fit Check': 'fitment_notes',
        'Fitment Table': 'fitment_table',
        'Product Results': 'rendered_results',
    };
    return Object.prototype.hasOwnProperty.call(handles, group) ? components[handles[group]].label : group;
};
